import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import { FeatureTaxReportListComponent } from './tax-report-list/feature-tax-report-list.component';
import {SharedUiButtonModule} from "@snelstart/ui-button";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, FeatureTaxReportListComponent],
  declarations: [],
  exports: [FeatureTaxReportListComponent],
})
export class FeatureTaxReportListModule {}
